const constants = {
  isDevelopment: process.env.NODE_ENV === 'development',
};

export default constants;
